import { render, staticRenderFns, recyclableRender, components } from "./qywx_qrcode.vue?vue&type=template&id=d4137238&"
var renderjs
import script from "./qywx_qrcode.vue?vue&type=script&lang=js&"
export * from "./qywx_qrcode.vue?vue&type=script&lang=js&"
import style0 from "./qywx_qrcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop/qywx_qrcode.vue"
export default component.exports